import React, { ReactNode } from "react";
import { Body, Container, Head, Html, Preview } from "@react-email/components";

const Layout = ({
  language = "en",
  title,
  preview,
  children,
  containerStyle,
  style,
}: {
  children: ReactNode;
  language?: string;
  preview?: string;
  title: string;
  containerStyle?: React.CSSProperties;
  style?: React.CSSProperties;
}) => (
  <Html lang={language} style={html}>
    <Head>
      <title>{title}</title>
    </Head>
    <Body
      style={{
        ...main,
        ...style,
      }}
    >
      {preview ? <Preview>{preview}</Preview> : null}
      <Container
        style={{
          ...container,
          ...containerStyle,
        }}
      >
        {children}
      </Container>
    </Body>
  </Html>
);

const html = {
  backgroundColor: "#fff",
  background: "#fff",
};

const main = {
  margin: "40px auto",
  width: "100%",
  backgroundColor: "#fff",
  background: "#fff",
  paddingBottom: "32px",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
};

const container = {
  paddingLeft: "12px",
  paddingRight: "12px",
  paddingTop: "32px",
  paddingBottom: "32px",
  width: "100%",
  background: "#fff",
  backgroundColor: "#fff",
  color: "#fff",
  margin: "0 auto",
};

export default Layout;
